export type TradeSide = 'C' | 'V';
export type DebitCredit = 'D' | 'C';

export interface StatementTrade {
  side: TradeSide,
  market: string,
  title: string,
  observation: string,
  quantity: number,
  price: number,
  total: number,
  debitCredit: DebitCredit
}

export interface StatementPreview {
  noteNumber: string,
  date: string,
  trades: StatementTrade[],
  totalOperations: number,
  liquidationTax: number,
  registrationTax: number,
  emoluments: number,
  transferTax: number,
  clearing: number,
  iss: number,
  issPisCofins: number,
  totalExpenses: number,
  settlementDate: string,
  netValue: number,
  netDebitCredit: DebitCredit | ''
}

export type ImportShareType = 'STOCK' | 'REIT';

// Value used in the selects to ask for a new record instead of an existing one
export const NEW_RECORD = '__new__';

export interface ImportAsset {
  title: string,
  type: ImportShareType,
  shareCode: string,
  matchedShare: boolean,
  newShare: { code: string, alias: string, dividends: boolean },
  companyCode: string,
  matchedCompany: boolean,
  newCompany: { name: string, code: string }
}

export interface ImportTrade {
  trade: StatementTrade,
  asset: ImportAsset,
  // Share of the note costs by traded value; only stocks carry it, REITs have no tax
  allocatedTax: number,
  tax: number
}

export interface ImportDraft {
  noteNumber: string,
  date: Date | null,
  assets: ImportAsset[],
  trades: ImportTrade[],
  alreadyImported: number
}

export interface ImportResult {
  companies: number,
  shares: number,
  stocks: number,
  reits: number
}
